import { useLocation, useNavigate } from "react-router-dom";
import SuccessScreen from "../../Common/SuccessScreen";

export const CompleteBuyerOnboarding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isInfluencer, isSupplierApprovalRequired, message } =
    location.state || {};

  const approvalRequired = !!isSupplierApprovalRequired;

  const title = isInfluencer
    ? "Successfully Onboarded & e-KYC Verified!"
    : "Onboarded Successfully";

  const filledButtonAction = () =>
    navigate(approvalRequired ? "/my-network" : "/inventory");
  const outlinedButtonAction = () => navigate("/");

  return (
    <SuccessScreen
      title={title}
      subtitle={message}
      filledButtonLabel={approvalRequired ? "My Network" : "Sell Products"}
      filledButtonAction={filledButtonAction}
      OutlinedButtonLabel="Home"
      OutlinedButtonAction={outlinedButtonAction}
      buttonContainerWidth={{ xs: "100%", sm: "565px" }}
    />
  );
};

export default CompleteBuyerOnboarding;
